import { useRef } from 'react';
import { KeyCode } from '../../internal/keycode';
import { filterOptions, isInteractive } from '../../internal/components/option/utils/filter-options';
import { useDebounceCallback } from '../../internal/hooks/use-debounce-callback';
export var isChar = function (keyCode) {
    return [0, KeyCode.enter, KeyCode.space, KeyCode.tab].indexOf(keyCode) === -1;
};
export var isRepeatedChar = function (str) { return str.split('').every(function (c) { return c === str[0]; }); };
function findMatchingOption(options, searchText, currentHighlight) {
    var filter = function (searchText) {
        return filterOptions(options, searchText, true).filter(function (option) { return isInteractive(option); });
    };
    var matchingOptions = filter(searchText);
    if (matchingOptions.length === 1) {
        return matchingOptions[0];
    }
    if (currentHighlight && searchText.length > 1 && isRepeatedChar(searchText)) {
        var matchingOptions_1 = filter(searchText[0]);
        if (matchingOptions_1.length > 0) {
            var active = matchingOptions_1
                .map(function (_a) {
                var option = _a.option;
                return option.value;
            })
                .indexOf(currentHighlight.value);
            active += 1;
            active = active % matchingOptions_1.length;
            return matchingOptions_1[active];
        }
    }
    if (matchingOptions.length > 0) {
        return matchingOptions[0];
    }
    return null;
}
export function useNativeSearch(_a) {
    var isEnabled = _a.isEnabled, options = _a.options, isKeyboard = _a.isKeyboard, highlightOption = _a.highlightOption, highlightedOption = _a.highlightedOption;
    var value = useRef('');
    var delayedResetValue = useDebounceCallback(function () { return (value.current = ''); }, 500);
    return function (event) {
        isKeyboard.current = true;
        if (!isEnabled) {
            return;
        }
        var charCode = event.charCode;
        if (!isChar(charCode)) {
            return;
        }
        delayedResetValue();
        var newValue = value.current + String.fromCharCode(charCode);
        value.current = newValue;
        var nextHighlight = findMatchingOption(options, newValue, highlightedOption);
        if (nextHighlight) {
            highlightOption(nextHighlight);
        }
    };
}
